export default __webpack_public_path__ + "static/media/it-4.ff936a7c.svg";